<template>
    <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingTietoaSivustosta"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingTietoaSivustosta"
                ref="modalHeadingTietoaSivustosta"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="modalButtonTietoaSivustosta"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
                @keydown.tab="handleCloseButtonTab"
            />
        </header>
        <section class="modal-body modal-font">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="textContent" />
            <!--eslint-enable-->
        </section>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class TietoaSivustostaModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingTietoaSivustosta as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get textContent(): string | null {
            return this.$t("App.TietoaSivustosta.InfoText") ?? ""
        }

        get header(): string | null {
            return this.$t("App.TietoaSivustosta.Header") ?? ""
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        // TODO LLa jos modaalin sis�lt��n tulee muita interaktiivisia elementtej� closeButtonin ja otsikon lis�ksi,
        // ne tulee huomioida kohdistuksen k�sittelyss� (trapFocus?)
        handleCloseButtonTab(event: KeyboardEvent): void {
            if (!event.shiftKey) /* tab */ {
                (this.$refs.modalHeadingTietoaSivustosta as HTMLHeadingElement).focus()
                event.preventDefault()
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonTietoaSivustosta as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
